import { render, staticRenderFns } from "./rules-table.vue?vue&type=template&id=2067691d&scoped=true"
import script from "./rules-table.vue?vue&type=script&lang=ts"
export * from "./rules-table.vue?vue&type=script&lang=ts"
import style0 from "./rules-table.vue?vue&type=style&index=0&id=2067691d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067691d",
  null
  
)

export default component.exports